export default __webpack_public_path__ + "static/media/virus_tracker.dd2b836b.png";